export default __webpack_public_path__ + "static/media/008-printer.422614e2.svg";